import React from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ApartmentIcon from "@mui/icons-material/Apartment";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FlagIcon from "@mui/icons-material/Flag";
import ShieldIcon from "@mui/icons-material/Shield"; // Strengths
import WarningAmberIcon from "@mui/icons-material/WarningAmber"; // Weaknesses
import ReportProblemIcon from "@mui/icons-material/ReportProblem"; // Threats
import TrackChangesIcon from "@mui/icons-material/TrackChanges"; // Personas / Target
import BusinessIcon from "@mui/icons-material/Business";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import KeyIcon from "@mui/icons-material/Key";
import StairsIcon from "@mui/icons-material/Stairs";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import BarChartIcon from "@mui/icons-material/BarChart";
import ReportIcon from "@mui/icons-material/Report";
import Person3Icon from "@mui/icons-material/Person3";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
// Map section labels to icons
export const ICON_MAP: Record<string, JSX.Element> = {
    summary: <DescriptionIcon sx={{ fontSize: 20 }} />,
    strengths: <FitnessCenterIcon sx={{ fontSize: 20 }} />,
    weaknesses: <WarningAmberIcon sx={{ fontSize: 20 }} />,
    opportunities: <StairsIcon sx={{ fontSize: 20 }} />,
    threats: <ReportProblemIcon sx={{ fontSize: 20 }} />,
    metrics: <TrendingUpIcon sx={{ fontSize: 20 }} />,
    marketing: <QueryStatsIcon sx={{ fontSize: 20 }} />,
    design: <DesignServicesIcon sx={{ fontSize: 20 }} />,
    UI: <DesignServicesIcon sx={{ fontSize: 20 }} />,
    "executive summary": <DescriptionIcon sx={{ fontSize: 20 }} />,
    "problem statement": <ContentPasteSearchIcon sx={{ fontSize: 20 }} />,
    "solution statement": <CheckCircleIcon sx={{ fontSize: 20 }} />,
    "market analysis": <QueryStatsIcon sx={{ fontSize: 20 }} />,
    "user personas": <SettingsAccessibilityIcon sx={{ fontSize: 20 }} />,
    "high-level requirements": <AssignmentIcon sx={{ fontSize: 20 }} />,
    "suggested goals and metrics": <TrendingUpIcon sx={{ fontSize: 20 }} />,
    "organization description": <ApartmentIcon sx={{ fontSize: 20 }} />,
    "market research": <QueryStatsIcon sx={{ fontSize: 20 }} />,
    "competitive analysis": <BarChartIcon sx={{ fontSize: 20 }} />,
    "user flow": <Person3Icon sx={{ fontSize: 20 }} />,
    "user journey": <Person3Icon sx={{ fontSize: 20 }} />,
    "marketing user personas": <Person3Icon sx={{ fontSize: 20 }} />,
    "risk assessment": <AnalyticsIcon sx={{ fontSize: 20 }} />,
    "internal stakeholder interviews": <QuestionAnswerIcon sx={{ fontSize: 20 }} />,
    "external stakeholder interviews": <QuestionAnswerIcon sx={{ fontSize: 20 }} />
};

export const getSectionIcon = (title: string) => {
    const key = title.trim().toLowerCase();
    // allow prefix matches like "Market Analysis and Bu..."
    const found = Object.keys(ICON_MAP).find(k => key.startsWith(k));
    return ICON_MAP[found ?? ""] ?? <DescriptionIcon sx={{ fontSize: 20 }} />;
};
